export default __webpack_public_path__ + "static/media/patrick-masbourian.e0d19cdc.gif";